query ListMMSES(
  $id: ID!
  $first: Int
  $last: Int
  $after: String
  $before: String
  $query: String
  $queryList: [QueryItemInput!]
) {
  mmsRequestsForAccount(
    accountId: $id
    first: $first
    last: $last
    after: $after
    before: $before
    query: $query
    queryList: $queryList
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        insertedAt
        updatedAt
        processedAt
        deliveredAt
        direction
        hostNumber
        remoteNumber
        remoteNeedDeliveryReceipt
        status
        errorCode
        remoteMessagingEnabled
        remoteReferenceId
        remoteCountryCode
        remoteTier
        account {
          id
          name
        }
      }
    }
  }
}
